import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiCall, guestIdParamLocalStorage } from '../../utils/apiCall';
import { getApiUrl } from '../../utils/apiHandler';
import { IdentifierOffset } from '../_declarations/globals';
import { ServicesPayload, ServicesResponse } from '../_declarations/services';

export const serviceDescriptionApi = createAsyncThunk<
  IdentifierOffset & ServicesResponse,
  ServicesPayload,
  { rejectValue: Error }
>(
  'services/service-description',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const state: any = getState();
      const serviceDescriptionUrl = getApiUrl('serviceDescription');
      const cachedDescription = state.services.services.find(
        (s: any) => s.id === payload.serviceDesc.serviceCode
      );
      if (cachedDescription) {
        return rejectWithValue('Service already exists' as unknown as Error);
      }
      const response: ServicesResponse = await apiCall({
        data: payload,
        headers: {
          Authorization: state?.auth?.value || '',
          SessionId: window.localStorage.getItem(guestIdParamLocalStorage) || ''
        },
        method: 'POST',
        url: serviceDescriptionUrl
      });

      return { id: payload.serviceDesc.serviceCode, ...response };
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);
